<template>
    <div class="careers-op">
      <div class="careers-op-content">
        <p>Всички наши актуални обяви можете да следите на адерс:<br>
          <a href="https://www.jobs.bg/company/11153#active_jobs" target="_blank">https://www.jobs.bg/company/11153#active_jobs</a>
          <br><br/>
          Можете да кандидатсвате, като ни изпратите своя автобиография на е-мейл: <a href="mailto:jobs@alcomet.eu">jobs@alcomet.eu</a>.
        </p>
        <br>
      </div>
      <app-share-button></app-share-button>
      <transition name="open-modal">
        <div v-if="selectedCareer" class="open-position-modal-wrapper">
          <div class="open-position-modal">
            <h1 class="open-position-modal-title">{{selectedCareer.title}}</h1>
            <div class="alcomet open-position-modal-close-btn" @click="closeModalFromBtn()">H</div>
            <div class="open-position-modal-content">
            <div class="open-position-modal-dates">
              <p>Начална дата: <strong>{{selectedCareer.startDate | formatDate}}</strong></p>
              <p>Крайна дата: <strong>{{selectedCareer.endDate | formatDate}}</strong></p>
            </div>
            <p class="open-position-modal-category-title"><span>Основни функции и отговорности</span></p>
            <div class="open-position-modal-category" v-html="selectedCareer.responsibilities"></div>
            <p class="open-position-modal-category-title"><span>Изисквания към кандидатите</span></p>
            <div class="open-position-modal-category" v-html="selectedCareer.requirements"></div>
            <p class="open-position-modal-category-title"><span>Допълнителна информация</span></p>
            <div class="open-position-modal-category" v-html="selectedCareer.additional"></div>
            <div class="btn-wrapper">
              <!-- <router-link class="application-btn" to="/careers/application-form"><span class="alcomet">r</span> Кандидатствай</router-link> -->
            </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  },
  data() {
    return {
      selectedCareer: "",
      careers: []
    };
  },
  methods: {
    getCareers() {
      this.$http
        .get(`${process.env.ROOT_API}/careers`)
        .then(response => {
          response.data.careers.forEach(item => {
            this.careers.push(item);
          });
        })
        .catch(error => {
          // handle error
          console.log(error);
        })
        .then(() => {
          // always executed
        });
    },
    closeModalFromBtn() {
      this.selectedCareer = "";
    },
    isCareerVisible(career) {
      const start = new Date(career.startDate).getTime();
      const end = new Date(career.endDate).getTime();
      let now = new Date();
      now.setHours(0, 0, 0, 0);
      now = now.getTime();
      if (start < now && now <= end) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.getCareers();
  }
};
</script>

<style scoped>
.careers-op-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  /* padding-top: 15px; */
}
.careers-op-content > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: center;
  width: 60%;
}
.careers-op-ul {
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  padding: 25px;
  width: 60%;
}
.careers-op-li {
  background-color: #edf2f4;
  cursor: pointer;
  display: block;
  border-radius: 6px;
  font-size: 19px;
  margin: 5px;
  padding: 15px 20px;
}
.careers-op-li:hover {
  background-color: rgba(237, 242, 244, 0.7);
}
/* MODAL */
.open-position-modal-wrapper {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
}
.open-position-modal {
  background-color: #f8fcfd;
  border-radius: 20px;
  -webkit-box-shadow: 0px 0px 150px -20px #083861;
  -moz-box-shadow: 0px 0px 150px -20px #083861;
  box-shadow: 0px 0px 150px -20px #083861;
  height: 90vh;
  overflow: hidden;
  padding: 60px 0 40px 100px;
  position: relative;
  width: 60%;
}
.open-position-modal-title {
  position: absolute;
  top: 20px;
  left: 0;
  text-align: center;
  width: 100%;
}
.open-position-modal-close-btn {
  align-items: center;
  border-top-right-radius: 20px;
  color: #c5d7e4;
  cursor: pointer;
  display: flex;
  font-size: 22px;
  height: 40px;
  justify-content: center;
  position: absolute;
  right: 10px;
  top: 10px;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 40px;
}
.open-position-modal-close-btn:hover {
  background-color: #dbebf4;
  color: #fff;
}
.open-position-modal-content {
  height: 100%;
  overflow: auto;
  padding-right: 100px;
}
.open-position-modal-dates {
  margin: 15px 0;
}
.open-position-modal-category {
  font-size: 14px;
  line-height: 20px;
}
.open-position-modal-category-title {
  padding: 30px 0;
}
.open-position-modal-category-title {
  font-size: 20px;
  text-align: center;
  position: relative;
}
.open-position-modal-category-title > span {
  background-color: #f8fcfd;
  font-weight: 700;
  padding: 0 15px;
  position: relative;
  z-index: 2;
}
.open-position-modal-category-title::before {
  content: "";
  background-color: rgba(0, 71, 135, 0.8);
  height: 1px;
  left: 0;
  position: absolute;
  top: 50%;
  width: 100%;
  z-index: 1;
}
.btn-wrapper {
  text-align: center;
}
.application-btn {
  align-items: center;
  border: 1px solid #588cc1;
  border-radius: 30px;
  display: inline-flex;
  font-size: 14px;
  font-weight: 700;
  height: 35px;
  justify-content: center;
  line-height: initial;
  margin: 30px 0 0;
  overflow: hidden;
  padding: 8px 20px 8px 10px;
  position: relative;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.application-btn span {
  margin-right: 10px;
}
.application-btn:hover {
  background-color: #dde7ee;
}
/* TRANSITION */
.open-modal-enter-active,
.open-modal-leave-active {
  transition: all 0.4s ease;
}
.open-modal-enter,
.open-modal-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
@media screen and (max-width: 1366px) {
  .careers-op-ul,
  .open-position-modal {
    width: 80%;
  }
}
@media screen and (max-width: 1000px) {
  .careers-op-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .open-position-modal-title {
    font-size: 24px;
  }
  .open-position-modal {
    padding-left: 40px;
  }
  .open-position-modal-content {
    padding-right: 40px;
  }
  .open-position-modal-dates > p {
    font-size: 14px;
  }
  .open-position-modal-category-title > span {
    font-size: 18px;
  }
  .careers-op-ul {
    width: 100%;
  }
  .careers-op-li {
    font-size: 14px;
  }
}
@media screen and (max-width: 600px) {
  .open-position-modal-title {
    font-size: 20px;
  }
  .open-position-modal {
    border-radius: 0;
    height: 100%;
    width: 100%;
  }
  .open-position-modal-category-title {
    margin-bottom: 10px;
    padding: 10px 0 0;
    border-bottom: 1px solid #004787;
  }
  .open-position-modal-category-title > span {
    font-size: 14px;
  }
  .open-position-modal-category-title::before {
    display: none;
  }
  .open-position-modal-category {
    font-size: 12px;
  }
}
@media screen and (max-width: 440px) {
  .open-position-modal-category-title {
    line-height: 14px;
    text-align: left;
    border-bottom: none;
  }
  .open-position-modal-category-title > span {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/careers/OpenPositions.vue